
import { Component, Vue, Watch } from 'vue-property-decorator';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { parseConcatNumber } from '@/utils/filters';
import { ElForm } from 'element-ui/types/form';
import { getBusinessStoreInfo, updateBusinessStoreInfo } from '@/api/businessStoreInfo';
import { UserModule } from '@/store/modules/user';
import { getOptionItemList } from '@/api/optionItem';
import ElementTipTap from '@/components/ElementTipTap/index.vue';
import { ref } from 'vue';

@Component({
  components: {
    VueDaumPostcode,
    ElementTipTap,
  },
})
export default class extends Vue {
  mounted() {
    this.getBusinessStoreInfo();
    getOptionItemList('NEWS_TITLE').then((res) => {
      this.newsTitleOptions = res.data;
    });
  }

  get industryIdx() {
    return UserModule.industry;
  }

  private apiUrl = process.env.VUE_APP_BASE_API;

  private findAddressVisible = false;

  private fileSizeLimit = 5;

  private loading = false;

  private tagInputVisible = false;

  private tagInputValue = '';

  private isDirty = false;

  private isInit = false;

  private clearDraft() {
    this.isDirty = false;
    localStorage.removeItem('namhae_store_form_draft');
  }

  private checkDraft() {
    const draft = localStorage.getItem('namhae_store_form_draft');
    if (draft) {
      this.$confirm('이전에 작성 중이던 내용이 있습니다. 불러오시겠습니까?', '임시 저장 불러오기', {
        confirmButtonText: '불러오기',
        cancelButtonText: '취소',
        type: 'info',
      }).then(() => {
        try {
          const parsed = JSON.parse(draft);
          this.storeForm = { ...this.storeForm, ...parsed };
          this.$message.success('임시 저장된 데이터를 불러왔습니다.');
        } catch (e) {
          console.error('Failed to parse draft', e);
        }
      }).catch(() => {
        this.clearDraft();
      });
    }
  }

  @Watch('storeForm', { deep: true })
  onFormChanged(newVal: any) {
    if (!this.isInit) return;
    this.isDirty = true;
    localStorage.setItem('namhae_store_form_draft', JSON.stringify(newVal));
  }

  created() {
    window.addEventListener('beforeunload', this.preventNav);
  }

  destroyed() {
    window.removeEventListener('beforeunload', this.preventNav);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.isDirty) {
      const isLogout = to.name === 'Login';
      const msg = isLogout
        ? '저장하지 않고 로그아웃 하시겠습니까?\n작성 중이던 내용은 모두 삭제되며 복구할 수 없습니다.'
        : '저장하지 않고 사이트 내에서 이동하시겠습니까?\n작성 중이던 내용은 임시 보관되지만, 변경사항이 완전히 저장되지 않을 수 있습니다.';
      if (window.confirm(msg)) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  private preventNav(event: any) {
    if (!this.isDirty) return;
    event.preventDefault();
    event.returnValue = '';
  }

  private addNoRest() {
    this.storeForm.holidayDayNum = '연중무휴';
  }

  private storeForm: any = {
    name: '',
    dao: '',
    // industryIdx: null,
    introduce: '',
    reserveLink: '',
    address: '',
    hashTag: [],
    addressDetail: '',
    addressCity: '',
    inquiryTel: '',
    newsList: [],
    tags: [],
    operations: [],
    etc: '-',
    operationTimeInfo: '',
    equipmentInfo: '',
    parkingInfo: '',
    locationInfo: '',
    reserveUrl: '',
    mediaUrl: '',
    images: [],
    surroundInfo: '',
    etcInfo: '',
    breakTimeStart: '',
    breakTimeEnd: '',
    holidayDayNum: [],
    courseInfo: '',
    entranceGuide: '',
    refundPolicyInfo: '',
    specialSearchStatus: false,
    formCompleteStatus: false,
  }

  private holidayDayNumCheck = false;

  private newsTitleOptions: any = [];

  private validateInquiryTel = (rule: any, value: any, callback: any) => {
    const reqInquiryTel = /^[0-9]{3}-[0-9]{3,4}-[0-9]{4}$/;
    if (!reqInquiryTel.test(value)) {
      callback(new Error('연락처 형식에 맞지 않습니다.'));
    } else {
      callback();
    }
  };

  /* eslint-disable */
  private rules = {
    name: [
      { required: true, message: '시설명을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    introduce: [
      { required: true, message: '소개글을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    inquiryTel: [
      { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
      { validator: this.validateInquiryTel, trigger: ['change', 'blur'] },
    ],
    address: [
      { required: true, message: '주소를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    hashTag: [
      { required: true, message: '해시태그를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    images: [
      { required: true, message: '이미지를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    tags: [
      // { required: true, message: '해시태그를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    operTime: [
      { required: true, message: '운영시간을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    reserveUrl: [
      {
        pattern: /(?:(?:(https?|http):\/\/|[\s\t\r\n\[\]\`\<\>\"\'])((?:[\w$\-_\.+!*\'\(\),]|%[0-9a-f][0-9a-f])*\:(?:[\w$\-_\.+!*\'\(\),;\?&=]|%[0-9a-f][0-9a-f])+\@)?(?:((?:(?:[a-z0-9\-가-힣]+\.)+[a-z0-9\-]{2,})|(?:[\d]{1,3}\.){3}[\d]{1,3})|localhost)(?:\:([0-9]+))?((?:\/(?:[\w$\-_\.+!*\'\(\),;:@&=ㄱ-ㅎㅏ-ㅣ가-힣]|%[0-9a-f][0-9a-f])+)*)(?:\/([^\s\/\?\.:<>|#]*(?:\.[^\s\/\?:<>|#]+)*))?(\/?[\?;](?:[a-z0-9\-]+(?:=[^\s:&<>]*)?\&)*[a-z0-9\-]+(?:=[^\s:&<>]*)?)?(#[\w\-]+)?)/gmi,
        message: '올바르지 않은 주소(링크)입니다.',
        trigger: 'blur',
      },
    ],
  }
  /* eslint-enable */

  private dayList = [
    { label: '월', value: 1 },
    { label: '화', value: 2 },
    { label: '수', value: 3 },
    { label: '목', value: 4 },
    { label: '금', value: 5 },
    { label: '토', value: 6 },
    { label: '일', value: 7 },
  ]

  getBusinessStoreInfo() {
    this.isInit = false;
    this.loading = true;
    getBusinessStoreInfo().then((res) => {
      this.loading = false;
      this.storeForm = {
        ...this.storeForm,
        ...res.data,
      };
      if (this.storeForm.newsList.length === 0) {
        this.storeForm.newsList.push({
          title: '',
          titleOptionIdx: null,
          content: '',
          startDate: '',
          endDate: '',
          dateRange: [],
        });
      }
      if (res.data.operations.length === 0) this.handleAddOper();
      this.storeForm.operations.forEach((oper: any) => {
        if (oper.startDate && oper.endDate) {
          // oper.dateRange = [oper.startDate, oper.endDate];
          this.$set(oper, 'dateRange', [oper.startDate, oper.endDate]);
        }
      });
      this.storeForm.newsList.forEach((news: any) => {
        if (news.startDate && news.endDate) {
          this.$set(news, 'dateRange', [news.startDate, news.endDate]);
        }
      });
      this.$nextTick(() => {
        (this.$refs.storeForm as ElForm).clearValidate();
      });
      if (res.data.tags.length === 0 && this.industryIdx === 1) {
        const tagsToAdd = ['남해여행', '남해관광', '남해숙소', '뷰맛집', '남해투어'];
        tagsToAdd.forEach((tag) => {
          if (!this.storeForm.tags.includes(tag)) {
            this.storeForm.tags.push(tag);
          }
        });
      }
      if (res.data.tags.length === 0 && this.industryIdx === 2) {
        const tagsToAdd = ['남해여행', '남해관광', '체험', '레저', '놀거리'];
        tagsToAdd.forEach((tag) => {
          if (!this.storeForm.tags.includes(tag)) {
            this.storeForm.tags.push(tag);
          }
        });
      }
      if (res.data.tags.length === 0 && this.industryIdx === 3) {
        const tagsToAdd = ['남해여행', '남해관광', '체험', '레저', '놀거리'];
        tagsToAdd.forEach((tag) => {
          if (!this.storeForm.tags.includes(tag)) {
            this.storeForm.tags.push(tag);
          }
        });
      }
      if (res.data.tags.length === 0 && this.industryIdx === 4) {
        const tagsToAdd = ['남해여행', '남해관광', '남해밥집', '맛집', '먹을거리'];
        tagsToAdd.forEach((tag) => {
          if (!this.storeForm.tags.includes(tag)) {
            this.storeForm.tags.push(tag);
          }
        });
      }
      if (res.data.tags.length === 0 && this.industryIdx === 5) {
        const tagsToAdd = ['남해여행', '남해관광', '남해굿즈', '기념품', '선물'];
        tagsToAdd.forEach((tag) => {
          if (!this.storeForm.tags.includes(tag)) {
            this.storeForm.tags.push(tag);
          }
        });
      }
      if (res.data.tags.length === 0 && this.industryIdx === 6) {
        const tagsToAdd = ['남해여행', '남해관광', '남해투어', '문화생활', '즐길거리'];
        tagsToAdd.forEach((tag) => {
          if (!this.storeForm.tags.includes(tag)) {
            this.storeForm.tags.push(tag);
          }
        });
      }
      this.handleHolidayDayNumCheckAll();
      this.$nextTick(() => {
        this.isInit = true;
        this.checkDraft();
      });
    });
  }

  private handleFindAddress() {
    this.findAddressVisible = !this.findAddressVisible;
  }

  private handleCompleteFindAddress(data: any) {
    this.handleFindAddress();
    this.storeForm.address = data.roadAddress;
    console.log(data);
    this.storeForm.addressCity = data.bname1;
    this.storeForm.addressDetail = '';
  }

  private filterInquiryTel() {
    this.storeForm.inquiryTel = parseConcatNumber(this.storeForm.inquiryTel);
  }

  private async handleBeforeUpload(uploadFile: File) {
    const fileSizeLimitByMb = this.fileSizeLimit * 1024 * 1024;
    const isImageFile = uploadFile.type.split('/')[0] === 'image';
    if (!isImageFile) {
      this.$message.warning('이미지 파일만 업로드 가능합니다.');
      return false;
    }
    if (uploadFile.size > fileSizeLimitByMb) {
      this.$message.warning(`파일 업로드 최대용량은 ${this.fileSizeLimit}MB입니다.`);
      return false;
    }
    return true;
  }

  private handleRemoveImageFile(file: any) {
    const index = this.storeForm.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > -1) this.storeForm.images.splice(index, 1);
  }

  private async handleSuccessUploadImageFile(res: any) {
    await this.storeForm.images.push({ fileUid: res.uid });
  }

  private handleClickLeftFile(file: any) {
    const index = this.storeForm.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > 0) {
      this.storeForm.images.splice(index - 1, 0, this.storeForm.images.splice(index, 1)[0]);
    }
  }

  private handleClickRightFile(file: any) {
    const index = this.storeForm.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index < this.storeForm.images.length - 1) {
      this.storeForm.images.splice(index + 1, 0, this.storeForm.images.splice(index, 1)[0]);
    }
  }

  private handleClickSave() {
    (this.$refs.storeForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$confirm('정말 상점정보를 저장하시겠습니까?', '상점 정보 저장', {
          confirmButtonText: '저장',
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          this.storeForm.formCompleteStatus = true;
          updateBusinessStoreInfo(this.storeForm).then(() => {
            this.clearDraft();
            this.$message.success('상점 정보가 저장되었습니다.');
            this.getBusinessStoreInfo();
          });
        });
      } else {
        this.$confirm('미입력된 필드가 존재합니다. 현재 숙소정보를 임시 저장하시겠습니까? ※ 임시 저장시 사용자에게 노출되지 않습니다.', '임시 저장', {
          confirmButtonText: '저장',
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          this.storeForm.formCompleteStatus = false;
          updateBusinessStoreInfo(this.storeForm).then(() => {
            this.clearDraft();
            this.$message.success('상점 정보가 임시 저장되었습니다.');
            this.getBusinessStoreInfo();
          });
        });
      }
    });
  }

  private handleHolidayDayNumCheckAll() {
    if (this.storeForm.holidayDayNum.length === 0) {
      this.holidayDayNumCheck = true;
    } else {
      this.holidayDayNumCheck = false;
    }
  }

  private handleClickAddTag() {
    this.tagInputVisible = !this.tagInputVisible;
  }

  private handleAddTag() {
    let inputValue = this.tagInputValue;
    inputValue = inputValue.trim();
    if (inputValue && this.storeForm.tags.length <= 5) {
      this.storeForm.tags.push(inputValue);
    }
    this.tagInputVisible = false;
    this.tagInputValue = '';
  }

  private handleRemoveTag(index: number) {
    this.storeForm.tags.splice(index, 1);
  }

  private handleAddNews() {
    this.storeForm.newsList.push({
      title: '',
      titleOptionIdx: null,
      content: '',
      startDate: '',
      endDate: '',
      dateRange: [],
    });
  }

  private handleDeleteNews(index: number) {
    this.storeForm.newsList.splice(index, 1);
  }

  private handleAddOper() {
    this.storeForm.operations.push({
      startDayNum: null,
      endDayNum: null,
      startDate: '',
      endDate: '',
      dateRange: ['', ''],
    });
  }

  private handleDeleteOper(index: number) {
    this.storeForm.operations.splice(index, 1);
  }

  /* eslint-disable */
  private handleChangeOperDateRange(index: number) {
    const oper = this.storeForm.operations[index];
    if (oper.dateRange && oper.dateRange.length === 2) {
      oper.startDate = oper.dateRange[0];
      oper.endDate = oper.dateRange[1];
    } else {
      oper.startDate = '';
      oper.endDate = '';
    }
  }

  private handleChangeNewsDateRange(index: number) {
    const news = this.storeForm.newsList[index];
    if (news.dateRange && news.dateRange.length === 2) {
      news.startDate = news.dateRange[0];
      news.endDate = news.dateRange[1];
    } else {
      news.startDate = '';
      news.endDate = '';
    }
  }

  private handleChangeNewsTitle(index: number) {
    const news = this.storeForm.newsList[index];
    if (news.titleOptionIdx === 27) {
      news.title = '';
    } else {
      const titleIndex = this.newsTitleOptions.findIndex((option: any) => option.idx === news.titleOptionIdx);
      const titleOption = this.newsTitleOptions[titleIndex];
      news.title = titleOption.name;
    }
  }

  private handleChangeEditor(val: string) {
    this.storeForm.courseInfo = val;
  }

  /* eslint-enable */

  private handleMakerFocus() {
    if (this.storeForm.surroundInfo === null) this.storeForm.surroundInfo = '•';
  }

  private handleMakerBlur() {
    if (this.storeForm.surroundInfo === '•') this.storeForm.surroundInfo = '';
  }

  private handleMaker(e: any, param: string) {
    if (e.key === 'Enter' && this.storeForm.surroundInfo[this.storeForm.surroundInfo.length - 1] !== '•') {
      if (param === 'etc') {
        this.storeForm.confirmationInfo += '•';
      } else {
        this.storeForm.surroundInfo += '•';
      }
    } else if (e.key === 'Backspace' && this.storeForm.surroundInfo === '') {
      if (param === 'etc') {
        this.storeForm.confirmationInfo = '•';
      } else {
        this.storeForm.surroundInfo = '•';
      }
    }
  }
}
